/**
 * Normalize a step's `actor` list to plain uid strings.
 *
 * The same field arrives in two shapes. A server read returns populated refs
 * (`[{ uid, name, ... }]`); a local edit round-trips through the form and
 * `handleStepComponentData`, which writes back what the form holds — bare uids
 * (`['abc', 'def']`). Reading it with `.map(a => a.uid)` therefore yields
 * `[undefined, ...]` for every locally-edited step, which renders as an empty
 * role selector until the page is reloaded.
 */
export const toActorUids = (actor: any): string[] =>
  Array.isArray(actor)
    ? actor.map((a: any) => (typeof a === 'string' ? a : a?.uid)).filter(Boolean)
    : [];
